import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import AddIcon from '@atlaskit/icon/core/add';
import NoteIcon from '@atlaskit/icon/core/note';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { IconButton } from '@atlaskit/button/new';

import { sharedI18n } from './sharedI18n.ts';
import { useContextualNoteCreation } from './hooks/useContextualNoteCreation.ts';
import { useContextualNotesList } from './hooks/useContextualNotesList.ts';

const NotesItems = ({
	handleAddToNoteClick,
}: {
	handleAddToNoteClick: (noteAri: string) => Promise<void>;
}) => {
	const { notesList } = useContextualNotesList();
	return (
		<DropdownItemGroup id="recent-notes">
			{notesList?.map((note, index) => (
				<DropdownItem
					elemBefore={<NoteIcon label="" />}
					key={index}
					onClick={() => handleAddToNoteClick(note.ari)}
				>
					{note.label}
				</DropdownItem>
			))}
		</DropdownItemGroup>
	);
};

export const HighlightActionsNotesButton = () => {
	const intl = useIntl();
	const [isOpen, setIsOpen] = useState(false);
	const { handleCreateNoteClick, handleAddToNoteClick } = useContextualNoteCreation({
		source: 'highlightActionsNotesButton',
	});

	return (
		<DropdownMenu
			isOpen={isOpen}
			onOpenChange={(attrs) => {
				setIsOpen(attrs.isOpen);
			}}
			shouldRenderToParent
			placement="bottom-start"
			trigger={(triggerProps) => (
				<div
					{...triggerProps}
					ref={triggerProps.triggerRef}
					id="highlight-actions-notes-button" // HighlightActions relies on this id to keep the menu open when this button is clicked
					data-testId="highlight-actions-notes-button"
				>
					<IconButton
						icon={NoteIcon}
						appearance="subtle"
						isSelected={isOpen}
						label={intl.formatMessage(sharedI18n.addToNote)}
						isTooltipDisabled={false}
						testId="highlight-actions-notes"
					/>
				</div>
			)}
		>
			<NotesItems handleAddToNoteClick={handleAddToNoteClick} />
			<DropdownItemGroup id="create-note" hasSeparator>
				<DropdownItem elemBefore={<AddIcon label="" />} onClick={handleCreateNoteClick}>
					<FormattedMessage {...sharedI18n.createNote} />
				</DropdownItem>
				{/* MODES-7119 Add view all notes button */}
			</DropdownItemGroup>
		</DropdownMenu>
	);
};
